/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientConfigResponse } from '../models/ClientConfigResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ConfigService {
  /**
   * Get public runtime config for the client app
   * @returns ClientConfigResponse OK
   * @throws ApiError
   */
  public static getClientConfig(): CancelablePromise<ClientConfigResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Config',
    });
  }
}
